import { Injectable } from '@angular/core';
import { InMemoryCacheService } from 'src/app/common/cache/in-memory-cache.service';
import { CoreService } from 'src/app/common/http-services/core.service';
import { environment } from 'src/environments/environment';
import { Charge, CreditCardCustomer } from 'src/app/components/payments/credit-card/credit-card.component';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private cache: InMemoryCacheService, private core: CoreService<{}>) { }

  public async createCustomer(customer: CreditCardCustomer, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.post(`${environment.billingServiceUrl}/customer`, customer));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async updateCustomer(customer: CreditCardCustomer, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.bulkPut(`${environment.billingServiceUrl}/customer/${customer.id}`, customer));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async createSubscription(sub: any, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.post(`${environment.billingServiceUrl}/subscription`, sub));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async attachPayment(paymentMethod: any, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.bulkPut(`${environment.billingServiceUrl}/customer/assignPaymentMethod`, paymentMethod));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async payInvoice(invoice: any, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.post(`${environment.billingServiceUrl}/invoice/payInvoice`, invoice));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async chargeCard(card: Charge, handleError: boolean = false) {
    const response = {data: null, error: null};
    try {
      response.data = await firstValueFrom(this.core.post(`${environment.billingServiceUrl}/payment/charge`, card));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  private handleError(error: any) {

  }


}
